import React from "react";
import { ApplicantIcon } from "~/assets/svg/InterfaceIcon";
import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import LoadingPage from "~/pages/LoadingPage";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";
import { useNavigate } from "react-router";

const List = ({ viewDetail, roundListData, loadingPage }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [
		{
			sidebar: { currentPath },
		},
	] = useGlobalStore();

	const [showAuthAlert, AuthAlert] = useAlert();

	return (
		<>
			<div className="c__cardRow">
				{!loadingPage ? (
					roundListData.length > 0 &&
					roundListData.map((list, index) => {
						return (
							<div
								className={
									list.status === "심사대기"
										? "c__card list-card waiting"
										: list.status === "심사중"
										? "c__card list-card open"
										: "c__card list-card close"
								}
								onClick={() => viewDetail(list.idx)}
							>
								{list.status !== "심사대기" && (
									<div className="c__tooltip-btn">
										<ApplicantIcon />
										<span className="c__tooltip">{list.applyCount}</span>
									</div>
								)}
								<div className="rounding-img">
									<img
										src={list.img}
										alt={t("pages.round.RoundList.component.List.roundImg")}
									/>
								</div>
								<div className="rounding-container">
									<h3 className="rounding-content">{list.title}</h3>
									<div className="rounding-container-footer">
										<span className="round-statue">{list.status}</span>
										{(list.status === "지원마감" ||
											list.status === "심사중" ||
											list.status === "진행중") && (
											<button
												type="button"
												className="btn__solid"
												color="primary"
												onClick={() => {
													if (currentPath.auth !== "edit") {
														showAuthAlert();
														return;
													}
													navigate(`/round/list/evaluate/${list.idx}`);
												}}
											>
												{t("pages.round.RoundList.component.List.evaluate")}
											</button>
										)}
										{/*--------관망하기*/}
										{/*<button*/}
										{/*	type="button"*/}
										{/*	className="btn__solid btn-view"*/}
										{/*	color="green"*/}
										{/*>*/}
										{/*	관망하기*/}
										{/*</button>*/}
									</div>
								</div>
							</div>
						);
					})
				) : (
					<LoadingPage />
				)}
			</div>
			{!loadingPage && roundListData.length === 0 && (
				<div className="c__noData">
					<CautionIcon />
					<p className="main">{t("pages.round.RoundList.component.List.noData")}</p>
				</div>
			)}
			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
		</>
	);
};

export default List;
